import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import PreSaleIntro from './PreSaleIntro/presale.intro.vue';
import PresaleListRow from '../../shared/PresaleListRow/presale.list.row.vue';
import { PreSaleModels } from '../../models/presale';
import { PresaleDataDelegate } from '../../services/DataDelegate/PresaleDelegate/presale.list.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../configs/config.common';
import { DingTalkAuth } from '../../services/DingTalkAuthentication/ding.talk.auth';

@Component({
    components: {
        Header,
        SpinLoader,
        NavSide,
        PreSaleIntro,
        PresaleListRow
    }
})
export default class PreSalePage extends Vue {
    public title: string = 'PreSalePage';

    public configs = new CommonConfig();

    public dingAuthService = new DingTalkAuth();

    public isLoading = false;

    public totalItemsAll = 100;

    public currentAll = 1;

    public totalItemsMy = 100;

    public currentMy = 1;

    public pageAll = 1;

    public pageMy = 1;

    public userInfo = {
        id: 'N/A',
        name: '',
        phone: '',
        wechat: '',
    };

    public listDataDelegate = new PresaleDataDelegate();

    public allProperties: PreSaleModels.IListRow[] = [
    ];

    public myProperties: PreSaleModels.IListRow[] = [
    ];

    public reset = true;

    @Watch('$store.state.presaleListStates.reload', { immediate: true, deep: true })
    public onReload(val: any, oldVal: any) {
        if (this.userInfo.id !== 'N/A') {
            this.reload();
        }
    }

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public onAuthenticated(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            this.userInfo.id = val.id;
            this.userInfo.name = T_T.simpleDetect(val.partner) ? val.partner.displayName : '';
            this.userInfo.phone = T_T.simpleDetect(val.xPhone) ? val.xPhone : '';
            this.userInfo.wechat = T_T.simpleDetect(val.xWechat) ? val.xWechat : '';
            this.isLoading = true;
            this.reload();
        }
    }

    public async reload() {
        this.isLoading = true;
        this.$store.commit('selectSection', '6');
        await this.listDataDelegate.getListings(this.pageAll);
        await this.listDataDelegate.getListings(this.pageMy, this.userInfo.id);
        this.allProperties = this.listDataDelegate.dataList;
        this.totalItemsAll = this.listDataDelegate.totalItems;
        this.myProperties = this.listDataDelegate.dataListMy;
        this.totalItemsMy = this.listDataDelegate.totalItemsMy;
        this.isLoading = false;
    }

    public async created() {
        // if (this.dingAuthService.isDingTalk()) {
        //     const val = this.$store.state.auth.userInfo;
        //     this.userInfo.id = val.id;
        //     this.userInfo.name = T_T.simpleDetect(val.partner.displayName) ? val.partner.displayName : '';
        //     this.userInfo.phone = T_T.simpleDetect(val.xPhone) ? val.xPhone : '';
        //     this.userInfo.wechat = T_T.simpleDetect(val.xWechat) ? val.xWechat : '';
        //     this.reload();
        // }
    }

    public async onPageChangeAll(pageNum: number) {
        this.pageAll = pageNum;
        this.isLoading = true;
        await this.listDataDelegate.getListings(pageNum);
        this.allProperties = this.listDataDelegate.dataList;
        this.totalItemsAll = this.listDataDelegate.totalItems;
        this.isLoading = false;
    }

    public async onPageChangeMy(pageNum: number) {
        this.pageMy = pageNum;
        this.isLoading = true;
        await this.listDataDelegate.getListings(pageNum, this.userInfo.id);
        this.myProperties = this.listDataDelegate.dataListMy;
        this.totalItemsMy = this.listDataDelegate.totalItemsMy;
        this.isLoading = false;
    }

}
